import { API_BASE_URL, API_CONFIG } from '../config';

// API endpoints
const API_URLS = {
  base: API_BASE_URL,
  ttsService: `${API_BASE_URL}/api/tts`,
  audioRecordingService: `${API_BASE_URL}/api/audio`,
  chatText: `${API_BASE_URL}/api/chat/text`,
  ttsToken: `${API_BASE_URL}/api/tts/token`,
  tutors: `${API_BASE_URL}/api/tutor/list`,
  avatars: (tutorId: string) => `${API_BASE_URL}/static/avatars/${tutorId}.webp`,
  audioMessage: `${API_BASE_URL}/api/chat/audio-message`,
  correction: `${API_BASE_URL}/api/chat/correction`,
  googleTTS: 'https://texttospeech.googleapis.com/v1/text:synthesize',
  translate: `${API_BASE_URL}/api/chat/translate`,
  simplify: `${API_BASE_URL}/api/chat/simplify`,
} as const;

// Export API configuration and endpoints
export { API_CONFIG, API_URLS };
